import React from "react";
import {DownloadLink, FileMetadata} from "../../gen/api";
import LinksEdit from "../LinksEdit/LinksEdit";
import FilesEdit from "../Files/FilesEdit";

type Props = {
  downloadLinks: DownloadLink[]

  handleNewDownloadLinkSubmit: (downloadLink: DownloadLink) => void
  handleDeleteDownloadLink: (downloadLink: DownloadLink) => void

  forms: FileMetadata[]
  handleNewFormSubmit: (form: FileMetadata) => void
  handleDeleteForm: (formId: string) => void
}

function DownloadEdit({
                        downloadLinks,
                        handleNewDownloadLinkSubmit,
                        handleDeleteDownloadLink,
                        forms,
                        handleNewFormSubmit,
                        handleDeleteForm
                      }: Props) {

  return (
      <>
          <LinksEdit links={downloadLinks} handleNewLinkSubmit={handleNewDownloadLinkSubmit} handleDeleteLink={handleDeleteDownloadLink}></LinksEdit>
          <FilesEdit forms={forms} handleNewFormSubmit={handleNewFormSubmit} handleDeleteForm={handleDeleteForm}></FilesEdit>
      </>
  );
}

export default DownloadEdit;